var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:{active: _vm.$route.name == _vm.routeName}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: _vm.routeName, params: _vm.allRouteParams}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef7b17ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/happypack/loader.js?id=eslint!./src/app/components/sidebar/SidebarLink.vue
// module id = 506
// module chunks = 8